/* Product page behaviour: gallery, variant pills, purchase options,
   quantity stepper and the info card accordions. One instance per
   main-product-vk section. */

(function () {
	function initSection(root) {
		if (root.dataset.vkpdReady === 'true') return;
		root.dataset.vkpdReady = 'true';

		var variantInput = root.querySelector('[data-vkpd-variant-id]');
		var priceNow = root.querySelector('[data-vkpd-price-now]');
		var priceWas = root.querySelector('[data-vkpd-price-was]');
		var saveBadge = root.querySelector('[data-vkpd-save]');
		var addButton = root.querySelector('[data-vkpd-add]');
		var stickyBar = root.querySelector('[data-vkpd-sticky]');
		var stickyAdd = root.querySelector('[data-vkpd-sticky-add]');
		var stickyPrice = root.querySelector('[data-vkpd-sticky-price]');
		var stickyVariant = root.querySelector('[data-vkpd-sticky-variant]');
		var variants = [];

		var variantData = root.querySelector('[data-vkpd-variants]');
		if (variantData) {
			try {
				variants = JSON.parse(variantData.textContent);
			} catch (e) {
				variants = [];
			}
		}

		var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

		function formatMoney(cents) {
			var amount = (cents / 100).toFixed(2);
			var parts = amount.split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			var withComma = parts.join('.');
			var noDecimals = parts[0];

			return moneyFormat
				.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
				.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
				.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
				.replace(/\{\{\s*amount\s*\}\}/g, withComma);
		}

		/* ------------------------------------------------------- gallery */

		var thumbs = root.querySelectorAll('[data-vkpd-thumb]');
		var stageItems = root.querySelectorAll('[data-vkpd-stage-item]');

		function showMedia(index) {
			for (var i = 0; i < stageItems.length; i++) {
				stageItems[i].classList.toggle('is-active', i === index);
			}
			for (var t = 0; t < thumbs.length; t++) {
				thumbs[t].classList.toggle('is-active', t === index);
			}
		}

		Array.prototype.forEach.call(thumbs, function (thumb, index) {
			thumb.addEventListener('click', function () {
				showMedia(index);
			});
		});

		/* Thumbnail slider: five in view, arrows page through the rest. */
		var track = root.querySelector('[data-vkpd-thumbs-track]');
		var thumbsPrev = root.querySelector('[data-vkpd-thumbs-prev]');
		var thumbsNext = root.querySelector('[data-vkpd-thumbs-next]');

		if (track && (thumbsPrev || thumbsNext)) {
			/* The rail runs down the left of the stage on a wide screen and
			   along the bottom on a narrow one, so which way it pages is read
			   off the track itself rather than assumed. */
			var isVertical = function () {
				return track.scrollHeight > track.clientHeight + 1;
			};

			var syncArrows = function () {
				var vertical = isVertical();
				var position = vertical ? track.scrollTop : track.scrollLeft;
				var maxScroll = vertical
					? track.scrollHeight - track.clientHeight
					: track.scrollWidth - track.clientWidth;
				if (thumbsPrev) thumbsPrev.disabled = position <= 1;
				if (thumbsNext) thumbsNext.disabled = position >= maxScroll - 1;
			};

			var page = function (direction) {
				if (isVertical()) {
					track.scrollBy({ top: direction * track.clientHeight, behavior: 'smooth' });
				} else {
					track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
				}
			};

			if (thumbsPrev) thumbsPrev.addEventListener('click', function () { page(-1); });
			if (thumbsNext) thumbsNext.addEventListener('click', function () { page(1); });
			track.addEventListener('scroll', syncArrows);
			window.addEventListener('resize', syncArrows);
			syncArrows();
		}

		/* -------------------------------------------------- variant pills */

		var optionValues = root.querySelectorAll('[data-vkpd-option-value]');

		function selectedOptions() {
			var chosen = [];
			var groups = root.querySelectorAll('[data-vkpd-option]');
			Array.prototype.forEach.call(groups, function (group) {
				var active = group.querySelector('.is-active');
				chosen.push(active ? active.dataset.value : null);
			});
			return chosen;
		}

		function findVariant(chosen) {
			for (var i = 0; i < variants.length; i++) {
				var variant = variants[i];
				var match = true;
				for (var o = 0; o < chosen.length; o++) {
					if (chosen[o] !== null && variant.options[o] !== chosen[o]) {
						match = false;
						break;
					}
				}
				if (match) return variant;
			}
			return null;
		}

		/* The sticky bar carries a copy of the price and the button, so both
		   follow whatever the pills select. */
		function setAddState(button, available) {
			if (!button) return;
			button.disabled = !available;
			button.textContent = available
				? button.dataset.addLabel || 'Add to cart'
				: button.dataset.soldOut || 'Sold out';
		}

		function applyVariant(variant) {
			if (!variant) {
				if (addButton) {
					addButton.disabled = true;
					addButton.textContent = addButton.dataset.soldOut || 'Unavailable';
				}
				if (stickyAdd) {
					stickyAdd.disabled = true;
					stickyAdd.textContent = stickyAdd.dataset.soldOut || 'Unavailable';
				}
				return;
			}

			if (variantInput) variantInput.value = variant.id;

			if (priceNow) priceNow.textContent = formatMoney(variant.price);

			var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
			if (priceWas) {
				priceWas.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
				priceWas.hidden = !onSale;
			}
			if (saveBadge) {
				if (onSale) {
					var off = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
					saveBadge.textContent = (saveBadge.dataset.label || 'Save') + ' ' + off + '%';
					saveBadge.hidden = false;
				} else {
					saveBadge.hidden = true;
				}
			}

			setAddState(addButton, variant.available);
			setAddState(stickyAdd, variant.available);

			if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

			/* Only present on a product that has real variants — on a single
			   variant product the serving line holds that slot instead. */
			if (stickyVariant) stickyVariant.textContent = variant.options.join(' / ');


			if (variant.url && window.history.replaceState) {
				window.history.replaceState({}, '', variant.url);
			}
		}

		Array.prototype.forEach.call(optionValues, function (button) {
			button.addEventListener('click', function () {
				var group = button.closest('[data-vkpd-option]');
				var siblings = group.querySelectorAll('[data-vkpd-option-value]');
				Array.prototype.forEach.call(siblings, function (sibling) {
					sibling.classList.toggle('is-active', sibling === button);
				});
				applyVariant(findVariant(selectedOptions()));
			});
		});

		/* ---------------------------------------------- mobile sticky bar */

		/* The bar shows only once the real buy box has left the top of the
		   screen, so it never doubles up with the button it stands in for.
		   CSS keeps it off desktop; the class is harmless there. */
		var buyBox = root.querySelector('.vkpd__buy');

		/* Everything that has to make room for the bar keys off this class,
		   so switching the bar off in the theme editor takes the room back. */
		document.body.classList.toggle('vkpd-has-sticky', !!stickyBar);

		/* The bar is rendered inside the section so its content stays with
		   the product, then moved to the end of the body. Fixed positioning
		   is only as reliable as its ancestors: the footer is positioned at
		   z-index 10, and anything up the chain that makes a stacking
		   context would trap the bar under it. As a child of the body there
		   is nothing left to trap it. */
		if (stickyBar && stickyBar.parentNode !== document.body) {
			var stale = document.querySelector('body > [data-vkpd-sticky]');
			if (stale && stale !== stickyBar) stale.parentNode.removeChild(stale);
			document.body.appendChild(stickyBar);
		}

		if (stickyBar && buyBox && 'IntersectionObserver' in window) {
			var buyBoxObserver = new IntersectionObserver(
				function (entries) {
					var entry = entries[0];
					var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
					stickyBar.classList.toggle('is-visible', scrolledPast);
				},
				{ threshold: 0 }
			);
			buyBoxObserver.observe(buyBox);
		}

		/* ------------------------------------------------ quantity stepper */

		var qtyInput = root.querySelector('[data-vkpd-qty]');
		var qtyMinus = root.querySelector('[data-vkpd-qty-minus]');
		var qtyPlus = root.querySelector('[data-vkpd-qty-plus]');

		function stepQuantity(delta) {
			var current = parseInt(qtyInput.value, 10);
			if (isNaN(current)) current = 1;
			var next = current + delta;
			if (next < 1) next = 1;
			qtyInput.value = next;
		}

		if (qtyInput && qtyMinus) qtyMinus.addEventListener('click', function () { stepQuantity(-1); });
		if (qtyInput && qtyPlus) qtyPlus.addEventListener('click', function () { stepQuantity(1); });

		/* The info rows are the theme's collapsible-content accordion —
		   collapsible-content.js binds them, nothing to do here. */

	}

	function initAll() {
		var sections = document.querySelectorAll('[data-vkpd-section]');
		Array.prototype.forEach.call(sections, initSection);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();

/* The FAQ further down the product page opens on its first question only.
   The block settings say so too, but the live theme has been slow to pick
   the template up, so the page states it itself. The buy box accordion is
   left alone it starts fully closed. */
(function () {
	function collapseFaq() {
		var lists = document.querySelectorAll(
			'.template-product .collapsible-content__items:not(.vkpd__cards)'
		);

		Array.prototype.forEach.call(lists, function (list) {
			if (list.dataset.vkpdFaqReady === 'true') return;
			list.dataset.vkpdFaqReady = 'true';

			var items = list.querySelectorAll('.collapsible-content__item');
			Array.prototype.forEach.call(items, function (item, index) {
				var answer = item.querySelector('.collapsible-content__answer');
				var open = index === 0;
				item.classList.toggle('active', open);
				if (answer) answer.style.display = open ? 'block' : 'none';
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', collapseFaq);
	} else {
		collapseFaq();
	}

	document.addEventListener('shopify:section:load', collapseFaq);
})();
